import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert,
  Checkbox,
  FormControlLabel,
  IconButton,
  Link
} from "@mui/material";
import { subscribeToNewsApi } from "../services/apiCalls"; // Assuming your API function is in services/apiCalls
import { Container } from "../common/Spacing";
import { AccessTime, Call, Email, Facebook, FacebookOutlined, Instagram, LocationOn } from "@mui/icons-material";
import { fetchSystemData } from "../services/apiCalls";

const Newsletter = () => {
  const [email, setEmail] = useState(""); // State for email input
  const [snackbarOpen, setSnackbarOpen] = useState(false); // State for snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // State for snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // State for snackbar type
  const [systemData, setSystemData] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
    logo: "",
    fbLink: "",
    instaLink: "",
  });


  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchSystemData();
        setSystemData({
          name: data?.name || "Company Name",
          address: data.address,
          phone: data?.phone || "+1 (234) 567-890",
          email: data?.email || "info@example.com",
          logo: data?.logo,
          fbLink: data?.fb_link,
          instaLink: data?.inst_link,
        });
      } catch (error) {
        console.error("Failed to fetch system data:", error);
      }
    };

    fetchData();
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value); // Update email state
  };

  const handleSubscribe = async () => {
    if (!email) {
      setSnackbarMessage("Please enter a valid email address!");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    try {
      await subscribeToNewsApi(email);
      setSnackbarMessage("You have successfully subscribed to our newsletter.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setEmail("");
    } catch (error) {
      setSnackbarMessage("Subscription failed! Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container

      sx={{
        backgroundImage: `url('/headphone.png')`,
        backgroundSize: 'auto 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundColor: "#f6f0e6",
        borderRadius: 0,
        position: 'relative',

        '@media (max-width:600px)': {
          backgroundImage: 'none',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url('/headphone.png')`,
            backgroundSize: 'auto 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: 0.3,
            // zIndex: -1,
          },
        },
      }}
    >
      <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center"
        px={4}
      >
        <Grid item xs={12} md={4.5}>

          <Typography
            fontWeight="bold"
            // fontSize="1.5rem"
            variant="h4"
            component="h1"
            fontSize="3rem"
            marginTop="4rem"
            className="flex flex-col items-center text-center md:flex-row md:items-start md:text-left"
            marginBottom="2rem"
            gutterBottom
          >
            Join the Newsletter Family
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}
            className="flex flex-col items-center text-center md:flex-row md:items-start md:text-left">
            <TextField
              variant="outlined"
              placeholder="Your Email here"
              fullWidth
              value={email} // Bind email state to the input field
              onChange={handleEmailChange} // Update email on input change
              sx={{
                backgroundColor: "#fff",
                border: "2px solid #000",
                borderRadius: 0,
                // marginTop:"1rem",
                marginBottom: "1rem",
                input: {
                  padding: "13px 20px",
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: 0,
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",

                  },
                },
                ":hover": {
                  border: "2px solid #9E6747",
                },
                "&.Mui-focused fieldset": {
                  border: "2px solid #9E6747",

                },
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubscribe} // Call handleSubscribe on button click
              sx={{
                backgroundColor: "#000",
                textTransform: "unset",
                fontWeight: "600",
                fontSize: "16px",
                borderRadius: 0,
                padding: "0.735em 2em",
                // marginTop:"1rem",
                marginBottom: "1rem",
                // marginLeft: "-9em",
                // boxShadow: "4.243px 4.243px 10px 0px rgba(30, 30, 30, 0.3)",
                ":hover": {
                  backgroundColor: "#9E6747",
                },
              }}
            >
              Submit
            </Button>
          </Box>
          <FormControlLabel

            control={<Checkbox />}
            label={
              <Typography fontSize={"14px"}>
                I Accept the Privacy and Cookies Policy to Received.
              </Typography>
            }
          />

          <Box
            className="flex flex-row items-center justify-center md:flex-row md:items-start md:justify-start"
            sx={{
              mt: 1,
              marginBottom: "3rem"

            }}>
            {systemData.fbLink && (
              <IconButton
                sx={{
                  color: "#ffffff",
                  bgcolor: "#000000",
                  marginRight: '1rem',
                  ":hover": {
                    bgcolor: "#9e6747",
                  }
                }}

                aria-label="Facebook"
                href={systemData.fbLink}
                target="_blank"
              >
                <FacebookOutlined sx={{ fontSize: "1.5rem" }} />
              </IconButton>
            )}
            {systemData.instaLink && (
              <IconButton
                sx={{
                  color: "#ffffff",
                  bgcolor: "#000000",
                  marginRight: '1rem',
                  ":hover": {
                    bgcolor: "#9e6747",
                  }
                }}

                aria-label="Instagram"
                href={systemData.instaLink}
                target="_blank"
              >
                <Instagram sx={{ fontSize: "1.5rem" }} />
              </IconButton>
            )}
          </Box>

        </Grid>

        {/* Right Side: Email Input and Subscribe Button */}
        <Grid item xs={12} md={2.5}>

        </Grid>

        <Grid item xs={12} md={2.5}>
          <Typography
            fontWeight="bold"
            fontSize="1.5rem"
            fontFamily="'Playfair Display', serif"
            className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left"
          >
            <LocationOn sx={{ fontSize: "2.5rem", marginBottom: "5px", color: "#9E6747" }} />&nbsp;Address
          </Typography>
          <Typography className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left">
            No: 58 A, East Madison Street, Baltimore, lg, USA 4508
          </Typography>

          <Typography
            fontWeight="bold"
            fontSize="1.5rem"
            fontFamily="'Playfair Display', serif"
            marginTop="2.5rem"
            className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left"
          >
            <Call sx={{ fontSize: "2.5rem", marginBottom: "5px", color: "#9E6747" }} />&nbsp;Call Us
          </Typography>
          <Typography className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left">
            <Link href="tel:+94778495831">+94 77 849 5831</Link>

          </Typography>
        </Grid>
        <Grid item xs={12} md={2.5}>
          <Typography
            fontWeight="bold"
            fontSize="1.5rem"
            fontFamily="'Playfair Display', serif"
            className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left"
          >

            <AccessTime sx={{ fontSize: "2.5rem", marginBottom: "5px", color: "#9E6747" }} />&nbsp;&nbsp;Business Hour
          </Typography>
          <Typography className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left">
            Weekdays - 9AM to 9PM<br />
            Sunday - Holiday
          </Typography>

          <Typography
            fontWeight="bold"
            fontSize="1.5rem"
            fontFamily="'Playfair Display', serif"
            marginTop="2.5rem"
            className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left"
          >

            <Email sx={{ fontSize: "2.5rem", marginBottom: "5px", color: "#9E6747" }} />&nbsp;&nbsp;Email Us
          </Typography>
          <Typography className="flex flex-col items-center text-center lg:flex-row lg:items-start lg:text-left">
            <Link href="mailto:tcomputerzone@gmail.com"> tcomputerzone@gmail.com</Link>

          </Typography>
        </Grid>

      </Grid>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Newsletter;
